module.exports = __webpack_public_path__ + "static/media/back-arrow.c6b94ec4.svg";